import { Send, Upload, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { getOfferContractTypes } from "@/lib/jobOffers";

const ApplicationFormModal = ({
  open,
  onClose,
  selectedJob,
  applicationData,
  cvFile,
  isSubmitting,
  onApplicationChange,
  onFileChange,
  onClearFile,
  onSubmit,
  fileInputId = "cv-upload-modal",
}) => {
  const contractTypes = selectedJob ? getOfferContractTypes(selectedJob) : [];
  const title = selectedJob ? `Postuler : ${selectedJob.title}` : "Candidature spontanée";

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent className="glass-card w-[calc(100%_-_2rem)] max-w-lg gap-0 border-white/10 p-6 md:p-8">
        <DialogHeader className="mb-6 pr-12 text-left">
          <DialogTitle className="font-heading text-xl font-semibold text-white">
            {title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            Complétez vos coordonnées et joignez votre CV au format PDF.
          </DialogDescription>
        </DialogHeader>
              <div>
                {selectedJob && (
                  <div className="-mt-4 mb-6 space-y-2">
                    {contractTypes.length > 0 && (
                      <div
                        className="flex flex-wrap items-center gap-2"
                        data-testid="application-job-contract-badges"
                      >
                        {contractTypes.map((contractType) => (
                          <span
                            key={`${selectedJob.id}-${contractType}`}
                            data-testid="application-job-contract-badge"
                            className="rounded-full border border-lenvia-blue/30 bg-lenvia-blue/10 px-2.5 py-1 text-xs text-lenvia-blue"
                          >
                            {contractType}
                          </span>
                        ))}
                      </div>
                    )}
                    {selectedJob.location && (
                      <p className="text-sm text-slate-400">{selectedJob.location}</p>
                    )}
                  </div>
                )}
            </div>

            <form onSubmit={onSubmit} className="space-y-5" data-testid="application-form-modal">
              <div>
                <label htmlFor="application-name" className="text-sm text-slate-300 mb-2 block">Nom complet *</label>
                <Input
                  id="application-name"
                  type="text"
                  name="name"
                  value={applicationData.name}
                  onChange={onApplicationChange}
                  placeholder="Jean Dupont"
                  required
                  className="form-input"
                />
              </div>

              <div>
                <label htmlFor="application-email" className="text-sm text-slate-300 mb-2 block">Email *</label>
                <Input
                  id="application-email"
                  type="email"
                  name="email"
                  value={applicationData.email}
                  onChange={onApplicationChange}
                  placeholder="jean.dupont@email.com"
                  required
                  className="form-input"
                />
              </div>

              <div>
                <label htmlFor="application-phone" className="text-sm text-slate-300 mb-2 block">Téléphone</label>
                <Input
                  id="application-phone"
                  type="tel"
                  name="phone"
                  value={applicationData.phone}
                  onChange={onApplicationChange}
                  placeholder="+33 6 12 34 56 78"
                  className="form-input"
                />
              </div>

              <div>
                <label htmlFor={fileInputId} className="text-sm text-slate-300 mb-2 block">
                  CV (PDF uniquement, max 5 Mo) *
                </label>
                <div className="relative">
                  <input
                    type="file"
                    id={fileInputId}
                    accept=".pdf"
                    onChange={onFileChange}
                    className="hidden"
                    data-testid="input-cv-upload-modal"
                  />
                  <label
                    htmlFor={fileInputId}
                    className="flex items-center justify-center gap-3 w-full p-4 border-2 border-dashed border-white/20 rounded-xl cursor-pointer hover:border-lenvia-blue/50 hover:bg-white/5 transition-all"
                  >
                    <Upload className="w-5 h-5 text-lenvia-blue" />
                    <span className="text-slate-300">
                      {cvFile ? cvFile.name : "Télécharger votre CV"}
                    </span>
                  </label>

                  {cvFile && (
                    <button
                      type="button"
                      onClick={() => onClearFile(fileInputId)}
                      className="absolute right-1 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-white/5 hover:text-red-400"
                      aria-label="Retirer le CV"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  )}
                </div>
              </div>

              <Button
                type="submit"
                className="btn-primary w-full justify-center"
                disabled={isSubmitting}
                data-testid="submit-application-modal"
              >
                {isSubmitting ? "Envoi en cours..." : "Envoyer ma candidature"}
                <Send className="w-4 h-4" />
              </Button>
            </form>
      </DialogContent>
    </Dialog>
  );
};

export default ApplicationFormModal;
